<div class="app-container">
  <navigator></navigator>
  <div class="app-content">
    <router-outlet></router-outlet>
    <navigation-spinner></navigation-spinner>
  </div>
</div>
